var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCenteralized(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Centeralized"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1073",
    cx: 9,
    cy: 9,
    r: 2,
    fill: "#878EA6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1074",
    cx: 9,
    cy: 9,
    r: 4.5,
    stroke: "#878EA6",
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1075",
    cx: 9,
    cy: 9,
    r: 7.5,
    stroke: "#878EA6",
    strokeDasharray: "8 5"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenteralized);
export default __webpack_public_path__ + "static/media/Centeralized.073e768aed062e6c2f88456f5330b6ff.svg";
export { ForwardRef as ReactComponent };